// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Orb-3","content":"styles_content__3uWdA","tableWrap":"styles_tableWrap__1oNyL"};